<template>
	<div class="map-part">
		<bigTitle mClass="mClass" :bigtitle="bigtitle" />
		<div class="flex part-1">
			<divBox1 title="各城市充换电电量统计">
				<myEchart
					v-if="powerExchangeMileageShow"
					:id="'PowerExchangeMileage'"
					:options="powerExchangeMileageOptions" />
			</divBox1>
			<divBox1 title="各城市充换电次数统计">
				<myEchart
					v-if="powerExchangeNumberShow"
					:id="'PowerExchangeNumber'"
					:options="powerExchangeNumberOptions" />
			</divBox1>
			<divBox1 title="各城市车辆平均充换电SOC">
				<myEchart
					v-if="cheliangSOCShow"
					:id="'CheliangSOC'"
					:options="cheliangSOCOptions" />
			</divBox1>
		</div>
	</div>
</template>

<script>
import divBox1 from '../divBox1'
import bigTitle from '../bigTitle'
import myEchart from './../charts/echarts'
import { dataInterface } from '@/api/dataInterfaceApi'
import * as echarts from 'echarts5'

export default {
	components: {
		divBox1,
		myEchart,
		bigTitle
	},
	data() {
		return {
			bigtitle: {
				CHN: '能源指标',
				ENG: 'Energy indicators',
			},
			// 各城市单车日均换电电量
			powerExchangeMileageOptions: {},
			powerExchangeMileageShow: false,
			// 各城市单车日均换电次数
			powerExchangeNumberOptions: {},
			powerExchangeNumberShow: false,
			// 各城市车辆平均换下SOC
			cheliangSOCOptions: {},
			cheliangSOCShow: false,
		}
	},
	props: {},
	watch: {},
	mounted() {},
	methods: {
		// 刷新接口需要每个子组件封装一个getData();
		getData(data) {
			console.log('sf123123123123123123123', data)
			// 各城市单车日均换电电量
			this.powerExchangeMileage(data)
			// 各城市单车日均换电次数
			this.powerExchangeNumber(data)
			// 各城市车辆平均换下SOC
			this.cheliangSOC(data)
		},
		
		// 各城市单车日均换电电量
		powerExchangeMileage(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				// 'enCode': 'quanguo-各城市单车日均换电里程',
				'enCode': 'quanguo-各城市单车日均充换电电量',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
        console.log(res, '各城市充换电电量统计')
				let data = res.sort(function(a, b) { 
					// return b.per_vehicle_daily_total_elect - a.per_vehicle_daily_total_elect
					return (parseFloat(b.per_vehicle_daily_exchange_elect || 0) + parseFloat(b.per_vehicle_daily_charge_elect || 0))
						- (parseFloat(a.per_vehicle_daily_exchange_elect || 0) + parseFloat(a.per_vehicle_daily_charge_elect || 0))
					})
				let xAxisData = []
				let seriesData1 = []
				let seriesData2 = []
				let seriesData3 = []
				let seriesData4 = []
				console.log('-======================quanguo-各城市单车日均充换电电量')
				console.log(data)
				data.map( item => {
					xAxisData.push(item.address)
					seriesData1.push(item.per_vehicle_daily_exchange_elect || 0) //单车日均换电电量
					seriesData2.push(item.per_vehicle_daily_charge_elect || 0) //单车日均充电电量
					seriesData3.push(item.exchange_elect || 0) //累计换电电量
					seriesData4.push(item.charge_elect || 0) //累计充电电量
					
				})
				this.powerExchangeMileageOptions = {
					title: {
						text: 'kwh',
						top: '3%',
						left: '2%',
						textStyle: {
							color: '#b3b3c9'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						data: xAxisData
					}],
					yAxis: [{
						type: 'value'
					},{
						type: 'value',
            name: 'kwh',
					}],
					series: [{
						name: '单车日均换电电量',
						type: 'line',
            yAxisIndex: '1',
						smooth: true,
						// stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 1, color: '#188df0' }
							])
						},
						data: seriesData1
					},
					{
						name: '单车日均充电电量',
						type: 'line',
            yAxisIndex: '1',
						smooth: true,
						// stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#B8FF7E' },
								{ offset: 1, color: '#65E2B6' }
							])
						},
						data: seriesData2
					},
					{
						name: '累计换电电量',
						type: 'bar',
            
						barWidth: 20,
						// stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 1, color: '#188df0' }
							])
						},
						data: seriesData3
					},
					{
						name: '累计充电电量',
						type: 'bar',
						barWidth: 20,
						// stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#B8FF7E' },
								{ offset: 1, color: '#65E2B6' }
							])
						},
						data: seriesData4
					}]
				}

				this.powerExchangeMileageShow = true
			})
		},
		
		// 各城市单车日均换电次数
		powerExchangeNumber(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo-各城市单车日均充换电次数',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000',
				'@OPER_TYPE':'充换电'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) {
					return (parseFloat(b.per_vehicle_daily_exchange_num || 0) + parseFloat(b.per_vehicle_daily_charge_num || 0))
						- (parseFloat(a.per_vehicle_daily_exchange_num || 0) + parseFloat(a.per_vehicle_daily_charge_num || 0))
				})
				let xAxisData = []
				let seriesData1 = []
				let seriesData2 = []
				let seriesData3 = []
				let seriesData4 = []
				console.log('-======================quanguo-各城市单车日均充换电次数')
				console.log(data)
				data.map( item => {
					xAxisData.push(item.address)
					seriesData1.push(item.per_vehicle_daily_exchange_num || 0) //单车日均换电次数
					seriesData2.push(item.per_vehicle_daily_charge_num || 0)  //单车日均充电次数
					seriesData3.push(item.exchange_num || 0) //累计换电次数
					seriesData4.push(item.charge_num || 0) //累计充电次数
					// seriesData.push({
					// 	value: parseFloat(item.per_vehicle_daily_exchange_num, 10),
					// 	itemStyle: {
					// 		borderRadius: 5,
					// 	}
					// })
				})
				this.powerExchangeNumberOptions = {
					title: {
						text: '次',
						top: '3%',
						left: '2%',
						textStyle: {
							color: '#b3b3c9'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						data: xAxisData
					}],
					yAxis: [{
						type: 'value'
					},{
						type: 'value',
            name: '次'
					}],
					series: [{
						name: '单车日均换电次数',
						type: 'line',
            yAxisIndex: '1',
						stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 1, color: '#188df0' }
							])
						},
						data: seriesData1
					},
					{
						name: '单车日均充电次数',
						type: 'line',
            yAxisIndex: '1',
						smooth: true,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#3DCAFF' },
								{ offset: 1, color: '#00FFD6' }
							])
						},
						data: seriesData2
					},
					{
						name: '累计换电次数',
						type: 'bar',
						barWidth: 20,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 1, color: '#188df0' }
							])
						},
						data: seriesData3
					},
					{
						name: '累计充电次数',
						type: 'bar',
						barWidth: 20,
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#3DCAFF' },
								{ offset: 1, color: '#00FFD6' }
							])
						},
						data: seriesData4
					}]
				}
				this.powerExchangeNumberShow = true
			})
		},

		// 各城市车辆平均换下SOC
		cheliangSOC(data = {}) {
			let params = {}
			let query = this.$route.query
			params = {
				'enCode': 'quanguo-各城市车辆平均换下SOC',
				'@VEHICLE_TYPE': query.vehicle == '1' ? '乘用车' : (query.vehicle == '2' ? '商用车' : '全部'),
				'@ADCODE': (data ? data.province || data.city || data.adcode : '') || '000000'
			}
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return;
				let data = res.sort(function(a, b) { //return b.down_soc - a.down_soc})
					return (parseFloat(b.exchange_down_soc || 0) + parseFloat(b.charge_start_soc || 0))
						- (parseFloat(a.exchange_down_soc || 0) + parseFloat(a.charge_start_soc || 0))
				})
				let xAxisData = []
				let seriesData1 = []
				let seriesData2 = []
				data.map( item => {
					xAxisData.push(item.address)
					seriesData1.push(item.exchange_down_soc || 0)
					seriesData2.push(item.charge_start_soc || 0)
					// seriesData.push({
					// 	value: parseFloat(item.down_soc, 10),
					// 	itemStyle: {
					// 		borderRadius: 5,
					// 	}
					// })
				})
				this.cheliangSOCOptions = {
					title: {
						text: '%',
						top: '3%',
						left: '2%',
						textStyle: {
							color: '#b3b3c9'
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					// grid: {
					// 	left: '3%',
					// 	right: '4%',
					// 	bottom: '3%',
					// 	containLabel: true
					// },
					xAxis: [{
						type: 'category',
						data: xAxisData
					}],
					yAxis: [{
						type: 'value'
					}],
					series: [{
						name: '换下SOC',
						type: 'bar',
						barWidth: 20,
						stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#3DCAFF' },
								{ offset: 1, color: '#00FFD6' }
							])
						},
						data: seriesData1
					},
					{
						name: '开始充电SOC',
						type: 'bar',
						barWidth: 20,
						stack: 'cheliangComparison',
						itemStyle: {
							color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 1, color: '#188df0' }
							])
						},
						data: seriesData2
					}]
				}
				this.cheliangSOCShow = true
			})
		},

	}
}
</script>

<style lang="scss" scoped>
@import './part.scss';
</style>